import { createAsyncThunk } from '@reduxjs/toolkit';
import DocumentResource from 'api/service/DocumentResource';

export const saveDocument = createAsyncThunk('artworks/saveDocument', async (initialData, { rejectWithValue }) => {
  const documentResource = new DocumentResource();
  const { document, params } = initialData;
  const { status, data } = await documentResource.save(document, params);
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Document save failed.');
});

export const exportDocument = createAsyncThunk('artworks/exportDocument', async (initialData, { rejectWithValue }) => {
  const documentResource = new DocumentResource();
  const { id } = initialData;
  const { status, data } = await documentResource.export(id);
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Document export failed.');
});

export const refreshDocument = createAsyncThunk(
  'artworks/refreshDocument',
  async (initialData, { rejectWithValue }) => {
    const documentResource = new DocumentResource();
    const { id } = initialData;
    const { status, data } = await documentResource.refresh(id);
    if (status === 200) {
      return data;
    }
    return rejectWithValue('Document refresh failed.');
  }
);
